export default [
    'tilt',
    "color",
    "fontname",
    "min_size",
    "max_size",
    "uppercase",
    'allow_flip',
    'orientation',
    "pivot_point",
    "min_size_distance",
    "max_size_distance",
    "min_visibility_distance",
    "max_visibility_distance",
    'use_orientation_from_camera',
    "min_fixed_direction_distance",
    "max_fixed_direction_distance",
]

export const customPropFlagsMapping = {
    tilt: 'custom_tilt',
    color: 'custom_color',
    fontname: 'custom_font',
    min_size: 'custom_icon_szie',
    max_size: 'custom_icon_szie',
    uppercase: 'custom_uppercase',
    allow_flip: 'custom_allow_flip',
    orientation: 'custom_orientation',
    pivot_point: 'custom_icon_pivot_point',
    min_size_distance: 'custom_icon_size_distance',
    max_size_distance: 'custom_icon_size_distance',
    min_visibility_distance: 'custom_icon_visibility_distance',
    max_visibility_distance: 'custom_icon_visibility_distance',
    use_orientation_from_camera: 'custom_use_orientation_from_camera',
    min_fixed_direction_distance: 'custom_icon_fixed_direction_distance',
    max_fixed_direction_distance: 'custom_icon_fixed_direction_distance',
}
